import { BaseClient } from '../client';
import { veiculosModelos } from '../offer/offer.mocks';
import { TVeiculoModelo } from '../offer/offer.types';

export const getAdminVehicleModels = async () => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return veiculosModelos;
	// }
	try {
		const response = await BaseClient.get<TVeiculoModelo[]>(`/VeiculoModelos`).then((response) => response.data);

		return response;
	} catch (error) {
		throw error;
	}
};
